module.exports = __webpack_public_path__ + "static/media/reflow-sticky6.a915f8ba.png";